import { create } from "zustand";

interface AnalyticsProps {
  pageName: string;
  userFlow: string;
  stepName: string;
  activeStoreAnalytics: boolean;

  setPageName: (page: string) => void;
  setUserFlow: (flow: string) => void;
  setStepName: (name: string) => void;
  setActiveStoreAnalytics: (status: boolean) => void;
}

export const useAnalyticsStore = create<AnalyticsProps>()((set) => ({
  pageName: "",
  userFlow: "",
  stepName: "",
  activeStoreAnalytics: false,

  setPageName: (page: string) => set(() => ({ pageName: page })),
  setUserFlow: (flow: string) => set(() => ({ userFlow: flow })),
  setStepName: (name: string) => set(() => ({ stepName: name })),
  setActiveStoreAnalytics: (status: boolean) => set(() => ({ activeStoreAnalytics: status })),
}));
